import { fromJS } from 'immutable';
import { endLoad, startLoad } from 'portaltransparencia-common/crud/Core.js';

import * as types from './Types.js';

const initialState = fromJS({
  consultaSic: [],
  consultaSicFisico: [],
  processoTramitacao: {},
  filtros: [],
  totalDiarias: {}
});

function ProcessoEsicReducer(state = initialState, action) {
  switch (action.type) {
    case types.FIND_TIPOESIC_START:
    case types.PROCESSO_START: {
      return startLoad(state);
    }

    case types.FIND_TIPOESIC_ERROR:
    case types.PROCESSO_ERROR: {
      return endLoad(state);
    }

    case types.FIND_TIPOESIC_SUCCESS: {
      if (action.meta && action.meta.fisico) {
        return endLoad(state.set('consultaSicFisico', fromJS(action.payload)));
      }
      return endLoad(state.set('consultaSic', fromJS(action.payload)));
    }
    case types.ESIC_SUCCESS: {
      if (action.meta && action.meta.fisico) {
        return endLoad(state.set('consultaSicFisico', fromJS(action.payload)));
      }
      return endLoad(state.set('consultaSic', fromJS(action.payload)));
    }
    case types.TOTAL_ESIC_SUCCESS: {
      return endLoad(state.set('totalEsic', fromJS(action.payload)));
    }
    case types.PROCESSO_SUCCESS: {
      return endLoad(state.set('processoTramitacao', fromJS(action.payload)));
    }

    case types.RESET_CONSULTA_ESIC: {
      return initialState;
    }
  }

  return state;
}

export default ProcessoEsicReducer;
